import React, { useState } from "react";
import styles from "../../../views/ReportView/ReportView.module.css";
import IconAnimation from "../../iconAnimation/iconAnimation";
import NotReportViewData from "../../NotReportViewData/NotReportView";
import { BiMessageAltError } from "react-icons/bi";
import { useNavigate } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa";

const TerrorismInformationComponent = ({ data }) => {
  const [user, setUser] = useState(data);
  const [isEditing] = useState(false);
  const navigate = useNavigate();

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setUser({ ...user, [name]: value });
  };

  const handleTerrorist = (e, user) => {
    const data = user;
    e.preventDefault();
    navigate("/lealtad/informe/terrorismo-pdf", { state: data });
  };

  return (
    <div className={styles.LealtadinformacionPolitica} id="terrorismo">
      <div className={styles.LealtadsectionTitle2}>
        <div className={styles.LealtadsectionTitle3}>
          <h2 className={styles.LealtadsectionTitleH2}>
            Información Terrorismo
          </h2>
          <IconAnimation />
        </div>       
        {!user ? (
           <></>
        ) : (
          <div className="abmlistviewbutton">
          <button
            type="button"
            id="idbuttonabmviewlist"
            className="buttonviewñostabm-lealtad"
            onClick={(e) => handleTerrorist(e, user)}
          >
            <i className="fa fa-refresh"></i> Terrorismo
            <FaArrowRight className={styles.Lealtadicon} />
          </button>
          </div>
        )}
        </div>
      {!user || !user.PoliticalInformation ? (
        <NotReportViewData
          title="Información Terrorismo"
          Icon={BiMessageAltError}
        />
      ) : (
        <div className={styles.Lealtadterroristbox}>
          <label className={styles.Lealtadinputfieldterrorism}>
            Verificación de terrorismo (DNI):
            <input
              className={styles.LealtadinputField}
              type="text"
              name="terrorismVerification"
              value={user.PoliticalInformation.terrorismVerification || ""}
              onChange={handleInputChange}
              readOnly={!isEditing}
            />
          </label>
          <label className={styles.Lealtadinputfieldterrorism}>
            Resultado: <br />
            <span className={styles.LealtadinputField}>
              {user.PoliticalInformation.verification}
            </span>
          </label>
        </div>
      )}
    </div>
  );
};

export default TerrorismInformationComponent;
